interface IMetaEnv {
    isDev: boolean;
    axiosLogger: boolean;
    reduxLogger: boolean;
    baseAPI: string;
    farmbookAPI: string;
    basepath: string;
    googleAPIKey: string;
    appVersion: string;
}

const metaEnv: IMetaEnv = {
    isDev: !!(import.meta.env.VITE_IS_DEV === "true"),
    axiosLogger: !!(import.meta.env.VITE_AXIOS_LOGGER === "true"),
    reduxLogger: !!(import.meta.env.VITE_REDUX_LOGGER === "true"),
    baseAPI: !!(typeof import.meta.env.VITE_BASE_API === "string") ? import.meta.env.VITE_BASE_API : "",
    farmbookAPI: !!(typeof import.meta.env.VITE_FARMBOOK_API === "string") ? import.meta.env.VITE_FARMBOOK_API : "",
    basepath: !!(typeof import.meta.env.VITE_BASE_PATH === "string") ? import.meta.env.VITE_BASE_PATH : "/admin",
    googleAPIKey: !!(typeof import.meta.env.VITE_GOOGLE_API_KEY === "string") ? import.meta.env.VITE_GOOGLE_API_KEY : "",
    appVersion: !!(typeof import.meta.env.VITE_APP_VERSION === "string") ? import.meta.env.VITE_APP_VERSION : ""
};

export default metaEnv;
